// extracted by mini-css-extract-plugin
module.exports = {"ReleaseNotes":"ReleaseNotes--Jd7YN"};